/**
 * ArticleLayoutImmersive - Immersive article layout wrapper
 * Applies CSS class for full-width immersive styling
 */
import React from 'react';

const ArticleLayoutImmersive = ({ children }) => {
    return (
        <div className="article-layout article-layout--immersive">
            <div className="article-layout__body">
                {children}
            </div>
        </div>
    );
};

export default ArticleLayoutImmersive;
